/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEventoDTOPayload } from './pratica-evento-dto-payload';
import { Actor } from './actor';


export interface PraticaEventoDTO { 
    id?: string;
    event_type?: PraticaEventoDTOEventTypeEnum;
    event_timestamp?: string;
    actor?: Actor;
    stato_da?: PraticaEventoDTOStatoDaEnum;
    stato_a?: PraticaEventoDTOStatoAEnum;
    payload?: PraticaEventoDTOPayload;
    payload_schema_version?: number;
}
export enum PraticaEventoDTOEventTypeEnum {
    PRATICA_CREATA = 'PRATICA_CREATA',
    PRATICA_SOTTOMESSA = 'PRATICA_SOTTOMESSA',
    PRATICA_RIAPERTA_PER_PATCH = 'PRATICA_RIAPERTA_PER_PATCH',
    PRATICA_PRESA_IN_CARICO = 'PRATICA_PRESA_IN_CARICO',
    PRATICA_ACCETTATA = 'PRATICA_ACCETTATA',
    PRATICA_RIFIUTATA = 'PRATICA_RIFIUTATA',
    PRATICA_RIPORTATA_IN_LAVORAZIONE = 'PRATICA_RIPORTATA_IN_LAVORAZIONE',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    OTP_GENERATO = 'OTP_GENERATO',
    OTP_REINVIATO = 'OTP_REINVIATO',
    OTP_CONFERMATO = 'OTP_CONFERMATO',
    OTP_FALLITO = 'OTP_FALLITO',
    PRATICA_DATI_AGGIORNATI = 'PRATICA_DATI_AGGIORNATI',
    ANAGRAFICA_AGGIORNATA = 'ANAGRAFICA_AGGIORNATA',
    NUCLEO_COMPONENTE_AGGIUNTO = 'NUCLEO_COMPONENTE_AGGIUNTO',
    NUCLEO_COMPONENTE_RIMOSSO = 'NUCLEO_COMPONENTE_RIMOSSO',
    NUCLEO_COMPONENTE_AGGIORNATO = 'NUCLEO_COMPONENTE_AGGIORNATO',
    ANAGRAFICA_CORRETTA_AB_ORIGINE = 'ANAGRAFICA_CORRETTA_AB_ORIGINE',
    PRATICA_DATI_CORRETTI_AB_ORIGINE = 'PRATICA_DATI_CORRETTI_AB_ORIGINE',
    NUCLEO_COMPONENTE_CORRETTO_AB_ORIGINE = 'NUCLEO_COMPONENTE_CORRETTO_AB_ORIGINE',
    PRATICA_ATTRIBUTI_CORRETTI_AB_ORIGINE = 'PRATICA_ATTRIBUTI_CORRETTI_AB_ORIGINE',
    ALLEGATO_CARICATO = 'ALLEGATO_CARICATO',
    ALLEGATO_RIMOSSO = 'ALLEGATO_RIMOSSO',
    PUNTEGGIO_RICALCOLATO = 'PUNTEGGIO_RICALCOLATO',
    PUNTEGGIO_OVERRIDDEN_MANUALMENTE = 'PUNTEGGIO_OVERRIDDEN_MANUALMENTE',
    COMUNICAZIONE_INVIATA = 'COMUNICAZIONE_INVIATA',
    COMUNICAZIONE_FALLITA = 'COMUNICAZIONE_FALLITA',
    NOTA_OPERATORE_AGGIUNTA = 'NOTA_OPERATORE_AGGIUNTA',
    NOTA_OPERATORE_CANCELLATA = 'NOTA_OPERATORE_CANCELLATA'
};
export enum PraticaEventoDTOStatoDaEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};
export enum PraticaEventoDTOStatoAEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};



